import Test from './Test.vue'

export default Test
